import { useCallback, useEffect, useMemo, useRef } from 'react'
import { Row, Input } from 'antd'
import { Icon } from '@iconify/react'
import AssigneeSelectPopover from '../../components/assigneeSelector'
import styles from '../../tasks.module.css'
import Button from '../../../../components/button/button'

const CreateTaskCard = ({
    createTask,
    setCreateTask,
    filteredAssignees,
    createTaskFromBoard,
    initialCreateTask,
}) => {
    const cardRef = useRef(null)
    const popoverRef = useRef(null)
    const inputRef = useRef(null)
    const inputValueRef = useRef(createTask?.text || '')

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cardRef?.current && !cardRef?.current.contains(event.target)) {
                setCreateTask(initialCreateTask)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [initialCreateTask, setCreateTask])

    const handleInputChange = (e) => {
        inputValueRef.current = e.target.value.trimStart()
    }

    const handleKeyUp = (e) => {
        if (
            (e.key === 'Enter' || e.key === 13) &&
            inputValueRef.current.length > 0
        ) {
            setCreateTask((prev) => ({
                ...prev,
                text: inputValueRef.current,
            }))
            createTaskFromBoard(inputValueRef.current)
        }
    }

    const selectedAssignee = useMemo(() => {
        return filteredAssignees.find(
            (data) => data?.value === createTask?.assigneeId
        )
    }, [filteredAssignees, createTask?.assigneeId])

    const handleAssigneeChange = useCallback(
        (selected) => {
            setCreateTask((prevState) => ({
                ...prevState,
                assigneeId: selected,
                text: prevState?.text,
            }))
        },
        [setCreateTask]
    )

    return (
        <div
            className={[styles.card, styles.createTaskCard].join(' ')}
            ref={cardRef}
            style={{
                opacity: createTask?.loading ? 0.5 : 1,
                pointerEvents: createTask?.loading ? 'none' : 'auto',
                position: 'relative',
            }}
        >
            {createTask?.loading && (
                <div className={styles.loaderCreateTask}></div>
            )}
            <Input
                className={styles.createTaskInput}
                placeholder="What needs to be done?"
                autoFocus
                defaultValue={createTask?.text}
                onChange={handleInputChange}
                onKeyUp={handleKeyUp}
                ref={inputRef}
            />
            <Row align="middle" justify="space-between">
                <AssigneeSelectPopover
                    assigneeList={filteredAssignees}
                    value={selectedAssignee}
                    onChange={handleAssigneeChange}
                    placement="bottom"
                    assigneeEmptyShow={false}
                    searchable
                    ref={popoverRef}
                />
                <Button
                    props={{
                        disabled: createTask?.text?.length === 0,
                        buttonType: 'text',
                        icon: (
                            <div
                                style={{
                                    border: '1px solid #595959',
                                    borderRadius: '5px',
                                    padding: '0px 1px',
                                }}
                                onClick={() => {
                                    if (createTask?.text?.length > 0) {
                                        createTaskFromBoard(createTask?.text)
                                    }
                                }}
                            >
                                <Icon icon="uil:enter" height={18} width={18} />
                            </div>
                        ),
                    }}
                />
            </Row>
        </div>
    )
}

export default CreateTaskCard
